import React from 'react';
import ButtonList from './ButtonList';
import VideoContainer from './VideoContainer';

const MainContainer = () => {
  return (
    <div className="mt-16"> {/* Add margin-top to push content down */}
     
      <VideoContainer />
    </div>
  );
};

export default MainContainer;

